<h1 mat-dialog-title>Require Account SetUp Assistance</h1>
Missing related Success Account for {{ssoSource}} user: {{username}} <br>
Please <a href="mailto:clientcare@firstlegal.com">contact support</a> to setup an Success Account
<div mat-dialog-actions>
    <button mat-raised-button mat-dialog-close color="primary" autofocus>Close</button>
</div>
